/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect } from "react";
import { Checkbox, Col, Row } from "antd";
import Axios from "axios";
import produce from "immer";
import { Title } from "./Common";
import MapPropsContext from "../MapPropsContext";
import { getApiHost } from "../../../utils";

import L from "leaflet";

import ICON_MOUNTAIN_1 from "../../../images/marker-mountain-1.png"; // 공원사무소
import ICON_MOUNTAIN_2 from "../../../images/marker-mountain-2.png"; // 대피소
import ICON_MOUNTAIN_3 from "../../../images/marker-mountain-3.png"; // 야영장
import ICON_MOUNTAIN_4 from "../../../images/marker-mountain-4.png"; // 위치표지판
import ICON_MOUNTAIN_5 from "../../../images/marker-mountain-5.png"; // 위험지역
import ICON_MOUNTAIN_6 from "../../../images/marker-mountain-6.png"; // 탐방로
import { TI_ADDITIONAL_INFO } from "../../../Constants";

const WidgetNationalParkExtraLayers = ({ currentPark }) => {
  const {
    updateMapLayerNames,
    mountainExtraLayerDict,
    setMountainExtraLayerDict,
  } = useContext(MapPropsContext);

  const insertLayer = useCallback(
    (parkTable) => {
      const url = getApiHost() + "/gis/nationalParkInfoList.json";
      const formData = new FormData();
      formData.append("parkTable", parkTable);
      formData.append("parkNm", encodeURI(currentPark.name));

      Axios.post(url, formData)
        .then((response) => {
          const { data } = response;
          const iconSize = [18, 22];
          const icon = L.icon({ iconUrl: ICON_MAP[parkTable], iconSize });

          setMountainExtraLayerDict((prevState) => ({
            ...prevState,
            [parkTable]: {
              icon,
              positionList: data.map(({ LON, LAT }) => [LAT, LON]),
            },
          }));
        })
        .catch((reason) => {
          console.error(reason);
        });
    },
    [currentPark]
  );

  // 추가정보 Checkbox, Change 리스너
  const onChange = useCallback(
    ({ target: { value, checked } }) => {
      const parkTable = value;
      console.log("parkTable :", parkTable, checked);

      if (!checked) {
        setMountainExtraLayerDict((prevState) =>
          produce(prevState, (draft) => {
            delete draft[parkTable];
            return draft;
          })
        );
      } else {
        setMountainExtraLayerDict((prevState) => ({
          ...prevState,
          [parkTable]: {},
        }));
        insertLayer(parkTable);
      }
    },
    [currentPark]
  );

  // 공원이 변경될 때, 선택되어있는 추가 레이어를 새로이 그립니다.
  useEffect(() => {
    Object.keys(mountainExtraLayerDict).forEach((parkTable) => {
      insertLayer(parkTable);
    });
  }, [currentPark]);

  return (
    <div>
      <Title>추가정보</Title>
      <Checkbox.Group disabled={!currentPark} style={{ width: "100%" }}>
        <Row>
          <Col span={12}>
            {makeCheckbox({
              parkTable: "GSTN_PARK_OFFICE_PT",
              label: "공원사무소",
              onChange,
              index: TI_ADDITIONAL_INFO,
            })}
          </Col>
          <Col span={12}>
            {makeCheckbox({
              parkTable: "GSTN_PARK_SHELTER_PT",
              label: "대피소",
              onChange,
              index: TI_ADDITIONAL_INFO + 1,
            })}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            {makeCheckbox({
              parkTable: "GSTN_CAMPG_PT",
              label: "야영장",
              onChange,
              index: TI_ADDITIONAL_INFO + 2,
            })}
          </Col>
          <Col span={12}>
            {makeCheckbox({
              parkTable: "GSTN_LC_SGNLBRD_PT",
              label: "위치표지판",
              onChange,
              index: TI_ADDITIONAL_INFO + 3,
            })}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            {makeCheckbox({
              parkTable: "GSTN_RISKAR_PT",
              label: "위험지역",
              onChange,
              index: TI_ADDITIONAL_INFO + 4,
            })}
          </Col>
          <Col span={12}>
            {makeCheckbox({
              parkTable: "GSTN_PMNTN_LN",
              label: "탐방로",
              onChange: ({ target: { checked } }) => {
                updateMapLayerNames("GSTN_PMNTN_LN", checked);
              },
              index: TI_ADDITIONAL_INFO + 5,
            })}
          </Col>
        </Row>
      </Checkbox.Group>
    </div>
  );
};

const makeCheckbox = ({ parkTable, label, onChange, index }) => {
  return (
    <Checkbox value={parkTable} onChange={onChange} tabIndex={index}>
      <img
        src={ICON_MAP[parkTable]}
        style={{ width: "16px", marginRight: "4px" }}
        alt={""}
      />
      {label}
    </Checkbox>
  );
};

const ICON_MAP = {
  GSTN_PARK_OFFICE_PT: ICON_MOUNTAIN_1,
  GSTN_PARK_SHELTER_PT: ICON_MOUNTAIN_2,
  GSTN_CAMPG_PT: ICON_MOUNTAIN_3,
  GSTN_LC_SGNLBRD_PT: ICON_MOUNTAIN_4,
  GSTN_RISKAR_PT: ICON_MOUNTAIN_5,
  GSTN_PMNTN_LN: ICON_MOUNTAIN_6,
};

export default WidgetNationalParkExtraLayers;
